import React from 'react'
import UserServicesContent from '../Components/Services/UserServicesContent';
import LoginLayout from '../Layouts/LoginLayout';

export default function Services() {
  return (
    <LoginLayout>
        <UserServicesContent />
    </LoginLayout>
  )
}
